var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83268 39.6673C6.7556 39.6673 5.83388 39.2841 5.06752 38.5178C4.30115 37.7514 3.91732 36.829 3.91602 35.7507V12.2507C3.91602 11.1736 4.29985 10.2518 5.06752 9.48548C5.83518 8.71912 6.7569 8.33529 7.83268 8.33398H19.5827L23.4993 12.2507H39.166C40.2431 12.2507 41.1655 12.6345 41.9331 13.4022C42.7008 14.1698 43.084 15.0915 43.0827 16.1673V35.7507C43.0827 36.8277 42.6995 37.7501 41.9331 38.5178C41.1668 39.2854 40.2444 39.6686 39.166 39.6673H7.83268Z",
    fill: "url(#paint0_linear_11335_7206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11335_7206",
    x1: 3.91602,
    y1: 24.0007,
    x2: 43.0827,
    y2: 24.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFolder);
export default __webpack_public_path__ + "static/media/download_folder.f1ea6b25ed7883b3d55df751a20d9923.svg";
export { ForwardRef as ReactComponent };